import { BasePage } from '@/components/ui/base-page'

export function InstitutionalBankingPage() {
  return (
    <BasePage
      title="Institutional Banking"
      description="Banking & Money movement for funds"
    >
      {/* Add InstitutionalBankingPage specific content here */}
    </BasePage>
  )
}